// Copyright 2021 Sorama B.V.

export class CreditsToDisplayFormatValueConverter {
    public toView(value: number): string {
        return CreditsToDisplayFormatValueConverter.convert(value);
    }

    public static convert(value: number | string): string {
        if (value === undefined) {
            value = 0;
        }
        if (typeof value === "string") {
            value = parseInt(value);
        }

        // 7654321 millicredits will be displayed as 7.654,32
        const kValue = value / 1000;
        return kValue.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
}
